//include 28
jQuery(function(){
    var defaultExpirationTime = 3600; //1 hour
    var storageKey = "ppSession";
    
    var storageSim = {
        storage:{},
        getItem(key){
            if(!!this.storage[key])
            {
                return this.storage[key];
            }
            return null;
        },
        setItem(key, value){
            this.storage[key] = value;
        }
    };

    if (typeof(window.Storage) !== "undefined") {
        var privateFunctions = {
            getStorage:function(){
                if(!window.pixelpoint.utilities.hasLocalStorage()){
                    return storageSim;
                }
                return window.localStorage;
            },
            setLocalStorageItem:function(key,value){
                var stringValue = JSON.stringify(value); 
                this.getStorage().setItem(key, stringValue);
            },
            getLocalStorageItem:function(key){
                var retrievedObject = this.getStorage().getItem(key);
                if(retrievedObject === null)
                    return null;
                return JSON.parse(retrievedObject);
                //return null;
            },
            update: function() {
                var loaded = this.getLocalStorageItem(storageKey);
                if (loaded == null) {
                    loaded = {
                        data: {},
                        expiration: moment().unix()
                    };
                }
                loaded.expiration = moment().add(defaultExpirationTime, 'seconds').unix();
                this.setLocalStorageItem(storageKey, loaded);
            },
            expired: function() {
                var loaded = this.getLocalStorageItem(storageKey);
                if (loaded != null && moment(loaded.expiration, 'X').isBefore(moment())) {
                    return true;
                }
                return false;
            },
            clear: function() {
                var loaded = {
                    data: {},
                    expiration: moment().add(defaultExpirationTime, 'seconds').unix()
                };
                this.setLocalStorageItem(storageKey, loaded);
            },
            checkAndUpdate: function() {
                if (this.expired()) this.clear();
                else this.update();
            },
            get: function(key) {
                this.checkAndUpdate();
                var loaded = this.getLocalStorageItem(storageKey);
                if (loaded == null) {
                    return null;
                }
                if (loaded.data.hasOwnProperty(key)) return loaded.data[key];
                else return null;
            },
            set: function(key, value) {
                this.checkAndUpdate();
                var loaded = this.getLocalStorageItem(storageKey);
                if (loaded != null) {
                    loaded.data[key] = value;
                    this.setLocalStorageItem(storageKey, loaded);
                }
            }
        };
        privateFunctions.checkAndUpdate();
        window.pixelpoint.sessionService = {
            get: function(key) {
                return privateFunctions.get(key);
            },
            set: function(key, value) {
                privateFunctions.set(key, value);
            },
            refresh: function() {
                privateFunctions.checkAndUpdate();
            }
        }
    } else {
        window.pixelpoint.sessionService = {}
    }    
});